// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bZ9wERlAEvJERvO7vhog {
  flex: 1 0 0;
  font-size: 14px;
}

.lFQ6lCuoD7u8posOZMbD {
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;
}

.n21qzWBbsBQaBMQoNTFE {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.zsfZNAWczUTM0k5bGxGg {
  flex: 1 0 0;
  color: var(--grey-color-60);
  font-family: var(--font-stack-full-book);
  font-size: 14px;
  font-style: normal;
  font-weight: 350;
  line-height: 20px;
  margin-bottom: 5px;
}

.nTiShi5dkQD1b40rkJ19 {
  border-top: 1px solid var(--grey-color-60);
  margin: 24px;
  width: 100%;
  max-width: 1000px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.k8BZtQbGGmRtNPLIlK1p {
  margin-top: 10px;
}

.GFAECUYfD2uGjtuUecv2 {
  color: var(--navbar-text-color);
  border: 1px solid var(--navbar-text-color) !important;
  margin-top: 10px;
}

._3DZJX38VO2gqYJ1Eycu8 {
  background-color: var(--grey-gradient-start-color-10);
  color: var(--grey-color-90);
}

.MGgkr1IF7SjUVJP66XsC {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
}

.GUmpiZAt5dDsCDYLMQYZ {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.m4a_L5AtGzWXR9VNcfrn {
  color: var(--Black, var(--grey-color-90));
  font-family: var(--font-stack-full-book);
  font-size: 24px;
  font-style: normal;
  font-weight: 800;
  line-height: 32px;
  padding: 7px 0px 10px 0px;
}

.uGvVyfJZI1SC2WqVOqvS {
  font-family: var(--font-stack-full-book);
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: right;
}

.Uu6gZy8_GMF8KpETpg3n {
  display: flex;
  padding: 32px 40px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  flex: 1 0 0;
  position: relative;
}

.zCnh0ydmawa0GvZSYmee {
  display: flex;
  align-items: flex-start;
  gap: 32px;
  flex: 1 0 0;
  margin: 14px 0 24px;
}

.Qvz5RgwIy2Wcy4FjnGOg {
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-book);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin: 0;
}

.iOlogTpSHSDmrmj2JYxD {
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
}

.Ta1msZFpYOnIMPKa5Ra8 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: -2px;
  align-self: stretch;
}

.wl61EIUThBMoeE0iEclE {
  display: flex;
  padding: 10px 12px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
}

.I8QyQJhUGquDVua62Mtu {
  border-radius: 12px;
  border: 1px solid var(--Grey-400, var(--grey-color-60));
  background: var(--White, var(--background-color));
}

.hFzDnDTU_EEV6I7ad6AL {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
}

.uGvVyfJZI1SC2WqVOqvS {
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-book);
  font-size: 14px;
  font-style: normal;
  font-weight: 350;
  line-height: normal;
}

.vSdLC40oUXgY2KSFRuvH {
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-book);
  font-size: 18px;
  font-style: normal;
  font-weight: 350;
  line-height: 24px;
}

.WVFDtPPGD0rWYsNAxZAb {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
}

.Uu6gZy8_GMF8KpETpg3n div[class*=content-inner] {
  margin: auto 8px auto 24px !important;
}
.Uu6gZy8_GMF8KpETpg3n div[class*=content-inner] > div > div {
  max-width: none !important;
  overflow: visible !important;
}

.ndheWDg5fbabAw_K8rGA {
  margin-top: 24px;
}

.HBq91_RgI7nT5sM64AOA {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.ZMQZjyZ0Dl68oSus_eNl {
  display: flex;
  align-items: flex-start;
  position: relative;
  width: 100%;
  min-height: 400px;
  gap: 205px;
}

.ug0asbwVD0POGpoP5lbz {
  flex: 0 1 auto;
}

.HSL1UrvwLiV24DmTjmd8 {
  position: sticky;
  top: 80px;
  right: 0;
  width: 553px;
  align-self: flex-start;
  flex-shrink: 0;
}

.kyjweCl5q1obljGhHcfZ {
  background-color: var(--card-bg-color, var(--grey-color-10));
  border-radius: 24px;
  padding: 20px 24px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
}

.bNt5CTSrlATew6IrBhSQ {
  color: var(--title-color, var(--grey-color-70));
  font-family: var(--font-stack-full-heavy);
  font-size: 18px;
  line-height: 24px;
  font-weight: 800;
  margin: 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #d9d9d9;
}

.KSI3BvX0iM4Zo8ddMbUJ {
  font-family: var(--font-stack-full-heavy);
  font-size: 48px;
  line-height: 56px;
  color: var(--title-color, var(--grey-color-90));
  font-weight: 700;
  margin-top: 16px;
  margin-bottom: 0;
}

._rtLpPjCohP8MIjfZMP0 {
  display: flex;
  gap: 12px;
  align-items: center;
  color: var(--orange-color-500);
  margin-left: 4px;
}

.Nk2j7pHHPiI5hZmMLuev {
  font-size: 18px;
  line-height: 24px;
  font-family: var(--font-stack-full-book);
  color: var(--orange-color-500);
  font-weight: 350;
}

.mFJ_FPU3uZraIl7PAKEv {
  border: 1px solid var(--grey-color-60) !important;
  border-radius: 12px !important;
  padding: 8px 12px !important;
}
.mFJ_FPU3uZraIl7PAKEv input {
  text-align: left !important;
}

.AyVoTtqGTgmKgCGIEpRy {
  position: absolute !important;
  right: 36px !important;
  left: auto !important;
}

.GNOJ7iTgDfv8m2bwPDpN {
  display: flex;
  width: 100%;
  max-width: 88vw;
  justify-content: space-between;
}

.yGGB9YwpCHnnsO7Yeiqz {
  max-width: 39%;
}

.LhJp1FC83UtEcgcNG_Th {
  margin-bottom: 24px;
}

.ee71YVAhXj19OaFBEuKv {
  margin-bottom: 10px;
  font-family: var(--font-stack-full-heavy);
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 24px;
  text-transform: capitalize;
}

.TkK6_ExqoJkfRI8qKt3h {
  position: relative;
  top: -60px;
}

.vVvcJ8XAMJEnaWgBbg6m {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px 24px 24px 24px;
  background-color: var(--grey-color-10);
  border-radius: 10px;
  height: 396px;
  gap: 8px;
  justify-content: center;
  margin-left: 24px;
}
.vVvcJ8XAMJEnaWgBbg6m td {
  background-color: var(--grey-color-10);
}
.vVvcJ8XAMJEnaWgBbg6m th {
  background-color: var(--grey-color-10);
}

.tZjywuWGGdXb7Gm3indf {
  background-color: var(--background-color);
  color: var(--grey-color-60);
  border-radius: 10px;
  font-family: var(--font-stack-full-regular);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  height: 28px;
  width: 100%;
  display: flex;
  padding-top: 4px;
  justify-content: center;
}

.z5FODklBmQh9wNUyYvJT {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
}

.JPQoxSDRaN5FUkkNmxSo {
  position: relative;
  top: -25px;
}

.TG3LCPky7SN1_RlG8okA {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.KWQDYEfD3XZap1opOLUo {
  width: 100%;
  max-width: 100%;
  height: auto;
  object-fit: contain;
  position: relative;
  z-index: 2;
  margin-top: 30px;
}

.Z0CzpbjJxj3W4ZTeZy10 {
  position: absolute;
  top: -9px;
  left: 49%;
  transform: translateX(-50%);
  font-family: var(--font-stack-full-heavy);
  font-size: 18px;
  font-weight: 800;
  color: var(--grey-color-70);
  text-align: center;
  line-height: 24px;
}

.qNoUNpVSr0kzZ_WCGP_a {
  position: absolute;
  left: -123px;
  top: 148;
  width: 200px;
  transform: rotate(-90deg);
  transform-origin: center center;
  font-family: var(--font-stack-full-heavy);
  font-size: 18px;
  font-weight: 800;
  color: var(--grey-color-70);
  white-space: nowrap;
  text-align: center;
  line-height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/CreateReport/CreateReport.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AACF;;AAEA;EACE,WAAA;EACA,2BAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,0CAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,+BAAA;EACA,qDAAA;EACA,gBAAA;AACF;;AAEA;EACE,qDAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AACF;;AAEA;EACE,yCAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AACF;;AAEA;EACE,wCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,2BAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,uDAAA;EACA,iDAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,2BAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,2BAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAGE;EACE,qCAAA;AAAJ;AAIE;EACE,0BAAA;EACA,4BAAA;AAFJ;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,gBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AAHF;;AAMA;EACE,4DAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;AAHF;;AAMA;EACE,+CAAA;EACA,yCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,gCAAA;AAHF;;AAMA;EACE,yCAAA;EACA,eAAA;EACA,iBAAA;EACA,+CAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAHF;;AAMA;EACE,eAAA;EACA,iBAAA;EACA,wCAAA;EACA,8BAAA;EACA,gBAAA;AAHF;;AAMA;EACE,iDAAA;EACA,8BAAA;EACA,4BAAA;AAHF;AAKE;EACE,2BAAA;AAHJ;;AAOA;EACE,6BAAA;EACA,sBAAA;EACA,qBAAA;AAJF;;AAOA;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,8BAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,mBAAA;AAJF;;AAOA;EACE,mBAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;AAJF;;AAOA;EACE,kBAAA;EACA,UAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,4BAAA;EACA,sCAAA;EACA,mBAAA;EACA,aAAA;EACA,QAAA;EACA,uBAAA;EACA,iBAAA;AAJF;AAKE;EACE,sCAAA;AAHJ;AAKE;EACE,sCAAA;AAHJ;;AAOA;EACE,yCAAA;EACA,2BAAA;EACA,mBAAA;EACA,2CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,UAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAJF;;AAOA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,+BAAA;EACA,yCAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAJF","sourcesContent":[".duplicateError {\n  flex: 1 0 0;\n  font-size: 14px;\n}\n\n.reportNameDescriptionContainer {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  align-self: stretch;\n}\n\n.reportColumns {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.reportNameDescription {\n  flex: 1 0 0;\n  color: var(--grey-color-60);\n  font-family: var(--font-stack-full-book);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 350;\n  line-height: 20px;\n  margin-bottom: 5px;\n}\n\n.mutator {\n  border-top: 1px solid var(--grey-color-60);\n  margin: 24px;\n  width: 100%;\n  max-width: 1000px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.cancelButton {\n  margin-top: 10px;\n}\n\n.continueButton {\n  color: var(--navbar-text-color);\n  border: 1px solid var(--navbar-text-color) !important;\n  margin-top: 10px;\n}\n\n.backButton {\n  background-color: var(--grey-gradient-start-color-10);\n  color: var(--grey-color-90);\n}\n\n.stepContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  align-self: stretch;\n}\n\n.stepTitleContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.stepTitle {\n  color: var(--Black, var(--grey-color-90));\n  font-family: var(--font-stack-full-book);\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 32px;\n  padding: 7px 0px 10px 0px;\n}\n\n.required {\n  font-family: var(--font-stack-full-book);\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: right;\n}\n\n.wrapper {\n  display: flex;\n  padding: 32px 40px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 32px;\n  flex: 1 0 0;\n  position: relative;\n}\n\n.stepOneContent {\n  display: flex;\n  align-items: flex-start;\n  gap: 32px;\n  flex: 1 0 0;\n  margin: 14px 0 24px;\n}\n\n.categoryHeading {\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-book);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28px;\n  margin: 0;\n}\n\n.continueButtonContainer {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  align-self: stretch;\n}\n\n.reportTitle {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: -2px;\n  align-self: stretch;\n}\n\n.inputGroup {\n  display: flex;\n  padding: 10px 12px;\n  align-items: center;\n  gap: 8px;\n  align-self: stretch;\n}\n\n.inputBox {\n  border-radius: 12px;\n  border: 1px solid var(--Grey-400, var(--grey-color-60));\n  background: var(--White, var(--background-color));\n}\n\n.reportTitleContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-self: stretch;\n}\n\n.required {\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-book);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 350;\n  line-height: normal;\n}\n\n.reportName {\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-book);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 350;\n  line-height: 24px;\n}\n\n.assessmentButtonContainer {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-top: 24px;\n}\n\n.wrapper {\n  div[class*=\"content-inner\"] {\n    margin: auto 8px auto 24px !important;\n  }\n\n  // Allow step 3 content to expand for leader count panel\n  div[class*=\"content-inner\"] > div > div {\n    max-width: none !important;\n    overflow: visible !important;\n  }\n}\n\n.infoContainer {\n  margin-top: 24px;\n}\n\n.buttonsContainer {\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.stepThreeContainer {\n  display: flex;\n  align-items: flex-start;\n  position: relative;\n  width: 100%;\n  min-height: 400px;\n  gap: 205px;\n}\n\n.stepThreeFilters {\n  flex: 0 1 auto;\n}\n\n.leaderCountWrapper {\n  position: sticky;\n  top: 80px;\n  right: 0;\n  width: 553px;\n  align-self: flex-start;\n  flex-shrink: 0;\n}\n\n.leaderCountCard {\n  background-color: var(--card-bg-color, var(--grey-color-10));\n  border-radius: 24px;\n  padding: 20px 24px;\n  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.leaderCountTitle {\n  color: var(--title-color, var(--grey-color-70));\n  font-family: var(--font-stack-full-heavy);\n  font-size: 18px;\n  line-height: 24px;\n  font-weight: 800;\n  margin: 0;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #d9d9d9;\n}\n\n.leaderCountValue {\n  font-family: var(--font-stack-full-heavy);\n  font-size: 48px;\n  line-height: 56px;\n  color: var(--title-color, var(--grey-color-90));\n  font-weight: 700;\n  margin-top: 16px;\n  margin-bottom: 0;\n}\n\n.leaderCountLimitationTextContainer {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  color: var(--orange-color-500);\n  margin-left: 4px;\n}\n\n.errorMessageIconAndText {\n  font-size: 18px;\n  line-height: 24px;\n  font-family: var(--font-stack-full-book);\n  color: var(--orange-color-500);\n  font-weight: 350;\n}\n\n.heatmapSelect {\n  border: 1px solid var(--grey-color-60) !important;\n  border-radius: 12px !important;\n  padding: 8px 12px !important;\n\n  input {\n    text-align: left !important;\n  }\n}\n\n.clearButton {\n  position: absolute !important;\n  right: 36px !important;\n  left: auto !important;\n}\n\n.heatmapGridContainer {\n  display: flex;\n  width: 100%;\n  max-width: 88vw;\n  justify-content: space-between;\n}\n\n.heatmapFilterSectionContainer {\n  max-width: 39%;\n}\n\n.heatmapGridLabelContainer {\n  margin-bottom: 24px;\n}\n\n.heatmapGridLabel {\n  margin-bottom: 10px;\n  font-family: var(--font-stack-full-heavy);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 24px;\n  text-transform: capitalize;\n}\n\n.heatmapGridBlurryImageContainer {\n  position: relative;\n  top: -60px;\n}\n\n.columnImageWrapper {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 24px 24px 24px 24px;\n  background-color: var(--grey-color-10);\n  border-radius: 10px;\n  height: 396px;\n  gap: 8px;\n  justify-content: center;\n  margin-left: 24px;\n  td {\n    background-color: var(--grey-color-10);\n  }\n  th {\n    background-color: var(--grey-color-10);\n  }\n}\n\n.moreCountText {\n  background-color: var(--background-color);\n  color: var(--grey-color-60);\n  border-radius: 10px;\n  font-family: var(--font-stack-full-regular);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  height: 28px;\n  width: 100%;\n  display: flex;\n  padding-top: 4px;\n  justify-content: center;\n}\n\n.heatmapImageWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  position: relative;\n}\n\n.heatmapImageWrapperWithLabel {\n  position: relative;\n  top: -25px;\n}\n\n.heatmapGridBlurryImage {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.heatmapGridWithLabelImage {\n  width: 100%;\n  max-width: 100%;\n  height: auto;\n  object-fit: contain;\n  position: relative;\n  z-index: 2;\n  margin-top: 30px;\n}\n\n.xAxisLabel {\n  position: absolute;\n  top: -9px;\n  left: 49%;\n  transform: translateX(-50%);\n  font-family: var(--font-stack-full-heavy);\n  font-size: 18px;\n  font-weight: 800;\n  color: var(--grey-color-70);\n  text-align: center;\n  line-height: 24px;\n}\n\n.yAxisLabel {\n  position: absolute;\n  left: -123px;\n  top: 148;\n  width: 200px;\n  transform: rotate(-90deg);\n  transform-origin: center center;\n  font-family: var(--font-stack-full-heavy);\n  font-size: 18px;\n  font-weight: 800;\n  color: var(--grey-color-70);\n  white-space: nowrap;\n  text-align: center;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"duplicateError": `bZ9wERlAEvJERvO7vhog`,
	"reportNameDescriptionContainer": `lFQ6lCuoD7u8posOZMbD`,
	"reportColumns": `n21qzWBbsBQaBMQoNTFE`,
	"reportNameDescription": `zsfZNAWczUTM0k5bGxGg`,
	"mutator": `nTiShi5dkQD1b40rkJ19`,
	"cancelButton": `k8BZtQbGGmRtNPLIlK1p`,
	"continueButton": `GFAECUYfD2uGjtuUecv2`,
	"backButton": `_3DZJX38VO2gqYJ1Eycu8`,
	"stepContainer": `MGgkr1IF7SjUVJP66XsC`,
	"stepTitleContainer": `GUmpiZAt5dDsCDYLMQYZ`,
	"stepTitle": `m4a_L5AtGzWXR9VNcfrn`,
	"required": `uGvVyfJZI1SC2WqVOqvS`,
	"wrapper": `Uu6gZy8_GMF8KpETpg3n`,
	"stepOneContent": `zCnh0ydmawa0GvZSYmee`,
	"categoryHeading": `Qvz5RgwIy2Wcy4FjnGOg`,
	"continueButtonContainer": `iOlogTpSHSDmrmj2JYxD`,
	"reportTitle": `Ta1msZFpYOnIMPKa5Ra8`,
	"inputGroup": `wl61EIUThBMoeE0iEclE`,
	"inputBox": `I8QyQJhUGquDVua62Mtu`,
	"reportTitleContainer": `hFzDnDTU_EEV6I7ad6AL`,
	"reportName": `vSdLC40oUXgY2KSFRuvH`,
	"assessmentButtonContainer": `WVFDtPPGD0rWYsNAxZAb`,
	"infoContainer": `ndheWDg5fbabAw_K8rGA`,
	"buttonsContainer": `HBq91_RgI7nT5sM64AOA`,
	"stepThreeContainer": `ZMQZjyZ0Dl68oSus_eNl`,
	"stepThreeFilters": `ug0asbwVD0POGpoP5lbz`,
	"leaderCountWrapper": `HSL1UrvwLiV24DmTjmd8`,
	"leaderCountCard": `kyjweCl5q1obljGhHcfZ`,
	"leaderCountTitle": `bNt5CTSrlATew6IrBhSQ`,
	"leaderCountValue": `KSI3BvX0iM4Zo8ddMbUJ`,
	"leaderCountLimitationTextContainer": `_rtLpPjCohP8MIjfZMP0`,
	"errorMessageIconAndText": `Nk2j7pHHPiI5hZmMLuev`,
	"heatmapSelect": `mFJ_FPU3uZraIl7PAKEv`,
	"clearButton": `AyVoTtqGTgmKgCGIEpRy`,
	"heatmapGridContainer": `GNOJ7iTgDfv8m2bwPDpN`,
	"heatmapFilterSectionContainer": `yGGB9YwpCHnnsO7Yeiqz`,
	"heatmapGridLabelContainer": `LhJp1FC83UtEcgcNG_Th`,
	"heatmapGridLabel": `ee71YVAhXj19OaFBEuKv`,
	"heatmapGridBlurryImageContainer": `TkK6_ExqoJkfRI8qKt3h`,
	"columnImageWrapper": `vVvcJ8XAMJEnaWgBbg6m`,
	"moreCountText": `tZjywuWGGdXb7Gm3indf`,
	"heatmapImageWrapper": `z5FODklBmQh9wNUyYvJT`,
	"heatmapImageWrapperWithLabel": `JPQoxSDRaN5FUkkNmxSo`,
	"heatmapGridBlurryImage": `TG3LCPky7SN1_RlG8okA`,
	"heatmapGridWithLabelImage": `KWQDYEfD3XZap1opOLUo`,
	"xAxisLabel": `Z0CzpbjJxj3W4ZTeZy10`,
	"yAxisLabel": `qNoUNpVSr0kzZ_WCGP_a`
};
export default ___CSS_LOADER_EXPORT___;
